import { render } from "./company.vue?vue&type=template&id=eeada9b6&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"

import "./company.vue?vue&type=style&index=0&id=eeada9b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eeada9b6"

export default script